import { useMemo } from 'react';
import {
  MyAnalyticsDimensionType,
  MyAnalyticsQuery,
  useMyAnalyticsQuery
} from 'graphql/types';
import { useNoteInsightsContext } from 'modules/Insights/Notes/NoteInsightsContextProvider';

export const useGetMyAnalyticsData = (
  dimension: MyAnalyticsDimensionType,
  labelId?: string
): {
  data: MyAnalyticsQuery | undefined;
  loading: boolean;
  isEmpty: boolean;
} => {
  const { currentPeriod } = useNoteInsightsContext();
  const { startDate, endDate } = currentPeriod ?? {};
  const { loading, data } = useMyAnalyticsQuery({
    variables: {
      input: {
        dimension,
        dateRange: {
          fromDate: startDate,
          toDate: endDate
        },
        labelId
      }
    },
    fetchPolicy: 'no-cache'
  });
  return useMemo(
    () => ({
      data,
      loading,
      isEmpty: data?.myAnalytics?.items.dimensions.length === 0
    }),
    [data, loading]
  );
};
